import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ToastContainer } from 'react-toastify';

import { App } from './app/app.js';
import { ErrorBoundary } from './app/error-boundary.js';
import { createQueryClient } from './app/query-client.js';
import { NotificationsProvider } from './app/notifications.js';
import { SessionProvider } from './auth/session.js';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.css';

const root = document.getElementById('root');

if (root === null) {
  throw new Error('The #root element is missing from index.html.');
}

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={createQueryClient()}>
        <BrowserRouter>
          <SessionProvider>
            <NotificationsProvider>
              <App />
              <ToastContainer
                position="top-right"
                autoClose={5000}
                newestOnTop
                closeOnClick
                pauseOnHover
                theme="colored"
              />
            </NotificationsProvider>
          </SessionProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
